import React from "react";
import PropTypes from "prop-types";

class EditFishForm extends React.Component {

    static propTypes = {
        fish: PropTypes.shape({
            image: PropTypes.string,
            name: PropTypes.string,
            desc: PropTypes.string,
            status: PropTypes.string,
            price: PropTypes.number
        }),
        index: PropTypes.string,
        updateFish: PropTypes.func
    };

    handleChange = (event) => {
        // this console logs the value of the target field
        console.log(event.currentTarget.value);
        // update that fish
        // 1. take a copy of the fish
        const updatedFish = {
            ...this.props.fish,
            [event.currentTarget.name]: event.currentTarget.value
        };
        this.props.updateFish(this.props.index, updatedFish);
        // this.props.index is used as key, was set in Inventory.js
    };

    render() {
        return (
           <div className="fish-edit">
               <input
                   type="text"
                   name="name"
                   onChange={this.handleChange}
                   value={this.props.fish.name}
               />
               <input
                   type="text"
                   name="price"
                   onChange={this.handleChange}
                   value={this.props.fish.price}
               />
               <select type="text" name="status" onChange={this.handleChange} value={this.props.fish.status}>
                   <option value="available">Fresh!</option>
                   <option value="unavailable">Sold Out!</option>
               </select>
               <textarea
                   name="desc"
                   onChange={this.handleChange}
                   value={this.props.fish.desc}
               />
               <input
                   type="text"
                   name="image"
                   onChange={this.handleChange}
                   value={this.props.fish.image}
               />
               <button onClick={() => this.props.deleteFish(this.props.index)}>
                   Remove Fish
               </button>
            </div>
        )
    }
}

export default EditFishForm;

// NOTES
//
// The onChange={this.handleChange} is needed because React will console error without it
// data in an edit form that has no onChange, because it wants all data stored in state
// and without an onChange React knows it is just text and not connected to state
//
// computed property names (new in ES6)
// [event.currentTarget.name]: event.currentTarget.value
// ^ this is why it was important to give each input tag a name


// WEBPACK FOOTER //
// ./src/components/EditFishForm.js